<template>
  <img class="logo" alt="Sckan NLI logo" src="./assets/sckan-nli-beta-logo.svg">
  <MainPanel/>
</template>

<script>
// import results from '../data/results.json'
import MainPanel from './components/MainPanel.vue';

export default {
  name: 'MainView',
  components: {
    MainPanel,
  },
  mounted() {
    const item = localStorage.getItem("signedIdToken")
    if (item) {
        console.log("signedIdToken (from localStorage):", item)
        const signedIdToken = JSON.parse(item)
        console.log("given name:", signedIdToken.given_name )
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.logo {
  width: auto;
  height: 200px;
}

</style>
